import { AbstractControl, ValidationErrors } from '@angular/forms';
import { BaseValidationError } from '@shared/validators/validation-error/base-error';
import { BaseValidator } from '@shared/validators/base-validator';
import { TranslationService } from '@core/translation/translation.service';
import { Person } from '@shared/models/person';

export class AddressExistsValidator extends BaseValidator {

    public validationError: BaseValidationError;

    constructor(message?: string) {
        super();

        this.validationError = new BaseValidationError(
            'addressExists',
            message || TranslationService.translate('common.validation.pickPersonFromList')
        );
    }

    public validate({value}: AbstractControl): ValidationErrors {
        return !value || (value instanceof Person && value.id != null) ?
            this.IS_VALID :
            this.IS_INVALID;
    }
}
